import React, { useState } from 'react';
import { Box, CheckCircle2Icon, Link, Text } from '@razorpay/blade/components';
import { useFormWithProvider } from 'forms';
import type { AttendanceSettingsFormState } from 'components/Settings/AttendanceAndLeavesSettings/types';
import { ModifyContractorAttendanceModal } from './ModifyContractorAttendanceModal';

export const ContractorsInfoCard = () => {
  const { formData, setFieldValue } = useFormWithProvider<AttendanceSettingsFormState>();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const description = formData.enableContractorsAttendance
    ? 'Attendance tracking is enabled for all your full-time employees and contractors'
    : 'Attendance tracking is enabled for all your full-time employees';

  const handleEnableOrDisableClick = () => {
    if (formData.enableContractorsAttendance) {
      setFieldValue('enableContractorsAttendance', false);
    } else {
      setIsModalOpen(true);
    }
  };

  return (
    <>
      <Box
        padding="spacing.6"
        borderRadius="medium"
        borderWidth="thin"
        borderColor="surface.border.gray.subtle"
        backgroundColor="surface.background.gray.intense"
        width="100%"
        display="flex"
        alignItems="flex-start"
        gap="spacing.4">
        <Box paddingTop="spacing.1">
          <CheckCircle2Icon color="feedback.icon.positive.intense" size="large" />
        </Box>

        <Box display="flex" flexDirection="column" gap="spacing.2">
          <Text size="large" weight="regular" color="surface.text.gray.normal">
            {description}
          </Text>
          <Link variant="anchor" onClick={handleEnableOrDisableClick}>
            {formData.enableContractorsAttendance
              ? 'Stop tracking contractors'
              : 'Track contractors?'}
          </Link>
        </Box>
      </Box>

      <ModifyContractorAttendanceModal
        isOpen={isModalOpen}
        onDismiss={() => setIsModalOpen(false)}
      />
    </>
  );
};
